// Module
var code = "<div class=\"btn-group btn-group-sm\"> <button class=\"btn btn-default\" title=\"{{button.tooltip|translate}}\" ng-class=\"{'btn-primary': button.period===vm.selectedPeriod}\" ng-click=\"vm.select(button)\" ng-repeat=\"button in vm.buttons\"> {{button.label|translate}} </button> </div>";
// Exports
module.exports = code;